import { format } from 'date-fns';
import styled, { css, keyframes } from 'styled-components';
import { IChannelReportContentDB } from 'type/db';
import { ICreatorContentsDB } from 'type/wconcepdb';

import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import CoreTag from 'shared/tag/CoreTag';
import { ReportSectionCard } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

const ContentCard = ({
	content,
	selected,
	_onClick,
}: {
	content: ICreatorContentsDB;
	selected: boolean;
	_onClick?: () => void;
}) => {
	return (
		<ContentCardWrapper select={selected} onClick={_onClick}>
			<Grid flex="between" _margin="0 0 8px 0">
				<Text typo="span">
					{format(new Date(content?.collaboratedDate ?? '0'), 'yyyy-MM-dd')}
				</Text>

				<CoreTag
					tag_type="text"
					color_type={'black'}
					value={`${new Date(content?.collaboratedDate ?? '0').getMonth() + 1}월`}
					_margin="0 0 4px 0"
				/>
			</Grid>

			<PostBox>
				<PostImg picture={content.contentImage} />
				<ContentTypeBox>
					<CoreSvg _size="16px" _fill="white">
						{content.contentType === 'Reels' ? <Icon.Video /> : <></>}
						{content.contentType === 'Feed' ? <Icon.Picture /> : <></>}
						{content.contentType === 'Shorts' ? <Icon.YoutubeShorts /> : <></>}
						{content.contentType === 'Branded' ? <Icon.Youtube /> : <></>}
					</CoreSvg>
					<Text typo="span_bold" color="white">
						{content.contentType}
					</Text>
				</ContentTypeBox>
			</PostBox>

			<Grid _height="100%" flex="between" direction="column">
				<EllipsisText typo="p_bold" _margin="4px 0">
					{content?.description ?? '-'}
				</EllipsisText>
				<Grid flex="start" direction="column">
					<Grid flex="between">
						<Text typo="span">조회 수</Text>
						<Text typo="span">{content?.viewCount?.toLocaleString() ?? '-'}회</Text>
					</Grid>

					<Grid flex="between">
						<Text typo="span">좋아요 수</Text>
						<Text typo="span">{content?.likeCount?.toLocaleString() ?? '-'}개</Text>
					</Grid>

					<Grid flex="between">
						<Text typo="span">댓글 수</Text>
						<Text typo="span">{content?.commentCount?.toLocaleString() ?? '-'}개</Text>
					</Grid>

					<Grid flex="between">
						<Text typo="span">클릭 수</Text>
						<Text typo="span">{content?.clickCount?.toLocaleString() ?? '-'}회</Text>
					</Grid>
				</Grid>
			</Grid>
		</ContentCardWrapper>
	);
};

const { Grid, Text } = style;

const post_ani = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

const PostBox = styled.div<{ animation?: boolean; delay?: string }>`
	width: 200px;
	height: 200px;
	flex-shrink: 0;
	border-radius: 8px;
	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	overflow: hidden;
	position: relative;
	${({ animation }) =>
		animation &&
		css`
			animation: ${post_ani} 2s infinite ease-in-out;
		`}
	${({ delay }) => delay && `animation-delay: ${delay}`};
`;

const PostImg = styled.div<{ picture?: string; color?: string }>`
	position: relative;
	padding-top: 100%;
	overflow: hidden;
	background-color: '#f8f8f8';
	background: url(${({ picture }) => picture}) no-repeat center / cover,
		url('/image/small_no_image.png') no-repeat center / cover;
`;

const EllipsisText = styled(Text)`
	width: 200px;
	${({ theme }) => theme.common.ellipsis_multi(2)};
`;

const ContentCardWrapper = styled(ReportSectionCard)<{ select: boolean }>`
	cursor: pointer;
	width: 258px;

	transition: 0.2s;

	border: 1px solid transparent;

	:hover {
		background-color: ${({ theme }) => theme.colors.uplus.bg10_lighten};
	}

	${({ select }) =>
		select &&
		css`
			border: 1px solid ${({ theme }) => theme.colors.gray.gray_black};
			:hover {
				background-color: ${({ theme }) => theme.colors.uplus.primary05};
			}
		`};
`;

export default ContentCard;

const ContentTypeBox = styled.div`
	position: absolute;
	bottom: 10px;
	right: 10px;
	background-color: rgba(0, 0, 0, 0.25);
	padding: 4px 8px;
	border-radius: 4px;
	height: 29px;
	width: 66px;
	display: flex;
	align-items: center;
	gap: 4px;
`;
